import "./index.css";
import Button from "../button";
import { useState, useEffect } from "react";
import { updateICP } from "../../functions/updateICP";
import { updatePersona } from "../../functions/updatePersona";

function SettingsEditor({ display, functionForButton, context }) {
  const [isError, SetIsError] = useState(false);
  const [errorMessage, SetErrorMessage] = useState("");
  const [textValue, setTextValue] = useState(""); // <-- New state for textarea
  const [placeholder,SetPlaceholder] = useState("")

    useEffect(() => {
      if(context==="ICP"){
        SetPlaceholder(`Let’s define your ICP (ideal customer profile).

Who are you writing for? Be as specific as you like.

This helps Mako tailor your content to maximise engagement.
`)
      }
      if(context==="persona"){
        SetPlaceholder(`Tell us a bit more about yourself.

What's your writing style? Are you fun and casual? Informative or serious? Confident or humble?

This is your *persona*, and it helps Mako better understand your voice.
`)
      }
    }, [context]);



  const handleClose = () => {
    functionForButton();
    SetIsError(false);
    SetErrorMessage("");
  };

  const handleSubmit = async() =>{
    if(context==="ICP"){
      await updateICP(textValue);
      window.location.reload();
    }
    if(context==="persona"){
      await updatePersona(textValue);
      window.location.reload();
    }
  }

    const handleTextChange = (event) => {
    setTextValue(event.target.value); // <-- Update state on change
  };

  const handleCloseClick = () =>{
    setTextValue("");
    handleClose();
  }





  return (
    <div id="blur-wrapper" style={{ display: display }}>
      <div id="settings-editing-module">
        <div className="input-module-title-holder">
          <h2 className="big-text">Edit {context}</h2>
          <button className="close-btn" onClick={handleCloseClick} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M1 1l14 14M15 1L1 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/></svg>
          </button>
        </div>

        <div className="small-text description">Edit your {context} to better tailor your content.</div>
        <textarea          
          className="persona-setting small-text"
          value={textValue}                // Bind value
          onChange={handleTextChange}      // Listen for edits
          placeholder={placeholder}
          >

        </textarea>

        {isError && <div id="error-message">{errorMessage}</div>}
      <Button text="Confirm" addedFunction={handleSubmit}></Button>
      </div>
    </div>
  );
}

export default SettingsEditor;